import { render, staticRenderFns } from "./TermsForm.vue?vue&type=template&id=7b4856d3&scoped=true"
import script from "./TermsForm.vue?vue&type=script&lang=ts"
export * from "./TermsForm.vue?vue&type=script&lang=ts"
import style0 from "./TermsForm.vue?vue&type=style&index=0&id=7b4856d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4856d3",
  null
  
)

export default component.exports